import qs from 'querystring';
import { StatusCodes } from 'http-status-codes';

import logger from 'logger';
import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import {
  ROSTER_URL,
  STUDIO_ADMINS_URL,
} from 'pages/StudioRoster/Api';
import {
  VALIDATE_EMAIL,
  VALIDATE_EMAIL_REGISTRATION_URL,
  VALIDATE_USERNAME,
  VALIDATE_USERNAME_REGISTRATION_URL,
} from 'pages/User/Api';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

const VALIDATE_STUDIO_NAME = `${BASE_URL}/rest/v1.0/studio/studio-name-validation`;
const headers = { 'content-type': 'application/x-www-form-urlencoded' };

const validateURLS = {
  username: VALIDATE_USERNAME,
  email: VALIDATE_EMAIL,
  studioName: VALIDATE_STUDIO_NAME,
};

const validateURLSNew = {
  username: VALIDATE_USERNAME_REGISTRATION_URL,
  email: VALIDATE_EMAIL_REGISTRATION_URL,
  studioName: VALIDATE_STUDIO_NAME,
};

export function registerStudioUser(data, username, onSuccess, onError, isAdmin = false) {
  const registrationType = isAdmin ? STUDIO_ADMINS_URL : ROSTER_URL;
  const URL = ApiService.substitute(registrationType, { studioOwnerName: encodeURIComponent(username) });
  const strData = qs.stringify(data);

  ApiService.post(URL, { data: strData, headers }).then(onSuccess).catch(onError);
}

export function apiValidateField(fieldName, value, onSuccess, onError) {
  const URL = validateURLS[fieldName];
  const strData = qs.stringify({ [fieldName]: value });

  ApiService
    .post(URL, { data: strData, headers })
    .then(onSuccess)
    .catch(({ response }) => {
      if (response.status === StatusCodes.BAD_REQUEST) {
        onError(response.data.code);
      } else {
        logger.error(response.statusText);
      }
    });
}

export function apiValidateFieldNew(fieldName, value, onSuccess, onError) {
  let URL = '';
  switch (fieldName) {
    case 'studioName':
      URL = validateURLSNew[fieldName];
      break;
    default:
      URL = validateURLSNew[fieldName].replace(`{${fieldName}}`, encodeURIComponent(value));
  }
  const strData = qs.stringify({ [fieldName]: value });
  const requestMethod = fieldName === 'studioName' ? 'post' : 'get';
  const config = {
    data: fieldName === 'studioName' && strData,
    headers: fieldName === 'studioName' && headers,
  };

  ApiService[requestMethod](URL, config)
    .then(onSuccess)
    .catch(({ response }) => {
      if (response.status === StatusCodes.BAD_REQUEST) {
        onError(response.data);
      } else {
        logger.error(response.statusText);
      }
    });
}

export const API_ERRORS = {
  studioName: {
    'studio_name_exists': 'homepage.v2.studio.studioName.error.taken',
    'invalid_studio_name': 'profile.v2.studio.error.message',
  },
  username: {
    'username_exists': 'profile.profile.username.error.taken',
    'username_censored': 'profile.profile.username.error.censored',
    'invalid_username': 'profile.profile.username.error.invalid',
    'no_username': 'profile.profile.username.error.empty',
    'username_ok': 'profile.profile.userName.error.ok',
    'invalid_numbers': 'profile.profile.username.error.invalidNumbers',
  },
  email: {
    'invalid_domain': 'contacts.contacts.email.error.invalidDomain',
    'email_exists': 'profile.profile.email.error.exists',
    'invalid_email': 'profile.profile.email.error.invalid',
    'email_ok': 'profile.profile.email.error.ok',
    'USER_FAN': 'fanclub.user.is.already.fan',
  },
  misc: {
    'database_error': 'Failed to check studio name in database',
    'user_failed_registration': 'Unregistered user failed registration',
  },
};
